module.exports = __webpack_public_path__ + "assets/media/lunch.fe5f8c25.mp3";